import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "terms-and-conditions rounded-lg m-8 px-8 bg-white" }
const _hoisted_2 = { class: "py-4" }
const _hoisted_3 = ["href"]
const _hoisted_4 = ["href"]
const _hoisted_5 = ["href"]

import { useI18n } from "vue-i18n";
import { useSeo } from "@/composables/useSeo";
import { COMPANY } from "@/constants/company";


export default /*@__PURE__*/_defineComponent({
  __name: 'LegalNotice',
  setup(__props) {

const { t } = useI18n();
useSeo({
  title: t("Legal notice"),
  description: t("Legal notice and company details of Medkus."),
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", null, [
      _createElementVNode("h2", _hoisted_2, [
        _createElementVNode("strong", null, _toDisplayString(_ctx.$t("Legal notice")), 1)
      ]),
      _createElementVNode("p", null, _toDisplayString(_ctx.$t("Medkus is a brand of {company}", { company: _unref(COMPANY).name })), 1),
      _createElementVNode("ul", null, [
        _createElementVNode("li", null, [
          _createElementVNode("strong", null, _toDisplayString(_ctx.$t("Company name")) + ":", 1),
          _createTextVNode(" " + _toDisplayString(_unref(COMPANY).name), 1)
        ]),
        _createElementVNode("li", null, [
          _cache[0] || (_cache[0] = _createElementVNode("strong", null, "RFC:", -1)),
          _createTextVNode(" " + _toDisplayString(_unref(COMPANY).rfc), 1)
        ]),
        _createElementVNode("li", null, [
          _createElementVNode("strong", null, _toDisplayString(_ctx.$t("Address")) + ":", 1),
          _createTextVNode(" " + _toDisplayString(_unref(COMPANY).address), 1)
        ]),
        _createElementVNode("li", null, [
          _createElementVNode("strong", null, _toDisplayString(_ctx.$t("Phone")) + ":", 1),
          _createElementVNode("a", {
            href: `tel:${_unref(COMPANY).phone.replace(/\s/g, '')}`
          }, _toDisplayString(_unref(COMPANY).phone), 9, _hoisted_3)
        ]),
        _createElementVNode("li", null, [
          _cache[1] || (_cache[1] = _createElementVNode("strong", null, "WhatsApp:", -1)),
          _createElementVNode("a", {
            href: `https://wa.me/${_unref(COMPANY).whatsapp.replace(/\D/g, '')}`
          }, _toDisplayString(_unref(COMPANY).whatsapp), 9, _hoisted_4)
        ]),
        _createElementVNode("li", null, [
          _createElementVNode("strong", null, _toDisplayString(_ctx.$t("Email")) + ":", 1),
          _createElementVNode("a", {
            href: `mailto:${_unref(COMPANY).email}`
          }, _toDisplayString(_unref(COMPANY).email), 9, _hoisted_5)
        ]),
        _createElementVNode("li", null, [
          _createElementVNode("strong", null, _toDisplayString(_ctx.$t("Website")) + ":", 1),
          _cache[2] || (_cache[2] = _createTextVNode(" https://medkus.com", -1))
        ])
      ]),
      _createElementVNode("p", null, _toDisplayString(_ctx.$t("Medkus is an integrative health platform and the domains medkus.com and market.medkus.com, along with their associated social media accounts, are owned and operated by {company}.", { company: _unref(COMPANY).name })), 1)
    ])
  ]))
}
}

})